import React, { FC } from 'react';

import agentExperienceConfigResource from 'src/actions/agentExperienceConfig/agentExperienceConfigResource';
import FormPage from 'src/presentation/components/pages/shared/FormPage';
import UsersSettingsForm from './UsersSettingsForm';

type UsersConfigProps = {
  resource: any;
};

const UsersConfig: FC<UsersConfigProps> = ({ resource }) => {
  const { errors, loadingState, value } = resource;

  return (
    <FormPage
      backButtonUrl="/users"
      backButtonLabel="Users"
      isLoading={loadingState === 'loading'}
      form={UsersSettingsForm}
      title="Users Settings"
      item={value}
      errors={errors}
      resetErrors={agentExperienceConfigResource.actions.resetErrors}
      data-aid="admin-users-settings-page"
    />
  );
};

export default UsersConfig;
